import { ConstructionModuleSwitcher } from './ConstructionModuleSwitcher';
import { CrmModuleSwitcher } from './CrmModuleSwitcher';

import type { TSmetterModuleSwitcherProps } from '../model/moduleSwitch';

export const SmetterModuleSwitcher = (props: TSmetterModuleSwitcherProps) => {
    if (props.source === 'construction') {
        return <ConstructionModuleSwitcher {...props} />;
    }

    return <CrmModuleSwitcher {...props} />;
};
